import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchPageBySlug } from '../services/api';
import { WebPage } from '../types/page.types';
import PageLoader from '../components/PageLoader';
import PageContent from '../components/PageContent';
import MicroFrontendLoader from '../microfrontends/MicroFrontendLoader';
import styles from './DynamicPage.module.css';

function DynamicPage() {
  const { slug, serviceSlug } = useParams();
  const [page, setPage] = useState<WebPage | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fullSlug = serviceSlug ? `services/${serviceSlug}` : slug || 'main';

  useEffect(() => {
    const loadPage = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchPageBySlug(fullSlug);
        setPage(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load page');
      } finally {
        setLoading(false);
      }
    };

    loadPage();
  }, [fullSlug]);

  if (loading) {
    return <PageLoader />;
  }

  if (error || !page) {
    return (
      <div className={styles.error}>
        <h1>Page Not Found</h1>
        <p>{error || 'The requested page could not be found.'}</p>
      </div>
    );
  }

  const isMicroFrontendPage = serviceSlug && ['seo-tools', 'network-tools', 'dev-tools'].includes(serviceSlug);

  return (
    <div className={styles.page}>
      <PageContent page={page} />
      {isMicroFrontendPage && <MicroFrontendLoader serviceType={serviceSlug} />}
    </div>
  );
}

export default DynamicPage;
